<template>
  <div class="app-select">
    <b-select v-bind="attributes" @input="onInput" v-if="!textMode"></b-select>
    <div v-else>
      <b-input-group>
        <b-input :value="textValueRef" :placeholder="textValuePlaceholder" @input="e => emit('changeText', e)" ref="textInput"></b-input>
        <b-input-group-append>
          <b-button @click="exitTextMode">
            <font-awesome-icon icon="times"/>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
  </div>
</template>

<script>
import { useAttrs, computed, ref, watch, nextTick } from "@vue/composition-api";

export default {
  props: {
    allowTextValue: {
      type: Boolean,
      default: false,
    },
    textValue: {
      type: String,
      default: null,
    },
    textValueLabel: {
      type: String,
      default: 'Anderes...'
    },
    textValuePlaceholder: {
      type: String,
      default: 'Text angeben'
    },
  },

  setup(props, { emit }) {
    const origAttributes = useAttrs()

    const textInput = ref(null)
    const textMode = ref(!!props.textValue)
    const textValueRef = ref(props.textValue)
    const lastValue = ref(origAttributes.value)

    const attributes = computed(() => {
      const attrs = {
        options: [],
        disabled: false,
        value: null,
        ...origAttributes,
      }
      if (props.allowTextValue && !attrs.options.map(o => o.text).includes(props.textValueLabel)) {
        attrs.options.push({
          text: props.textValueLabel,
          value: '--text--',
        })
      }
      return attrs
    })

    const onInput = val => {
      if (val === '--text--') {
        textMode.value = true
        nextTick(() => textInput.value.focus())
        val = null
      }
      emit('input', val)
    }

    const exitTextMode = () => {
      if (!lastValue.value) {
        const firstOption = attributes.value.options.length ? attributes.value.options[0] : null
        lastValue.value = firstOption ? firstOption.value : null
      }
      emit('input', lastValue.value)
      emit('changeText', null)
      textValueRef.value = null
      textMode.value = false
    }

    watch(textValueRef, () => {
      emit('changeText', textValueRef.value)
    })

    return {
      attributes,
      textInput,
      textMode,
      textValueRef,
      exitTextMode,
      onInput,
      emit,
    }
  }
}
</script>
